var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-button",
    {
      attrs: {
        loading: _vm.isLoading,
        size: _vm.size,
        type: _vm.type,
        disabled: _vm.disabled,
        plain: _vm.plain,
        icon: _vm.icon,
      },
      on: { click: _vm.clicked },
    },
    [_vm._v(_vm._s(_vm.btnText))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/btns/loadingBtn.vue?vue&type=template&id=3e5bfdd0&
// module id = null
// module chunks = 